import { CustomDataAdaptor } from "@syncfusion/ej2-data";
import { Observable } from "rxjs";
import { fakeHttpRequest } from "src/app/base/shared/fakeHttpRequest";

export class SimpleGetCustomAdaptor<T> extends CustomDataAdaptor {
  constructor(private getDataFunction: () => Observable<T[]>) {
    super();
    this.options.getData = this.getData.bind(this);
  }

  private getData(args) {
    const data = JSON.parse(args.data);
    if (this.getDataFunction == null) {
      args.onFailure('getDataFunction is null');
    }

    this.getDataFunction().subscribe({next: (result: T[]) => {
        args.onSuccess(result, {httpRequest: new fakeHttpRequest()});
      }, error: (error) => {
        args.onFailure('getData failed');
      }});
  }
}
